import { useState } from "react";

const InventoryDownloadHandler = ({
  rows,
  downloadHandler,
  setShowLoginPopup,
}) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);

  const handleHeaderCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    const allRowIds = rows.map((row) => row.id);

    if (isChecked) {
      setSelectedIds(allRowIds);
    } else {
      setSelectedIds([]);
    }
    setIsAllSelected(isChecked);
  };

  const toggleId = (id) => {
    const allRowIds = rows.map((row) => row.id);
    const updatedSelectedIds = selectedIds.includes(id)
      ? selectedIds.filter((item) => item !== id)
      : [...selectedIds, id];

    setSelectedIds(updatedSelectedIds);
    setIsAllSelected(updatedSelectedIds.length === allRowIds.length);
  };

  const isIdSelected = (id) => selectedIds.includes(id);

  const onDownloadClick = async () => {
    try {
      await downloadHandler(setShowLoginPopup, selectedIds);
      setSelectedIds([]);
      setIsAllSelected(false);
    } catch (error) {
      console.error("Error downloading Excel:", error);
    }
  };

  return {
    selectedIds,
    isAllSelected,
    handleHeaderCheckboxChange,
    toggleId,
    isIdSelected,
    onDownloadClick,
  };
};

export default InventoryDownloadHandler;
